import { StoryLevelData } from "@/app/lib/levels/story-level-data-types";
import { parseBuilderText } from "@/app/builder/build-parser";

const builderText =
`"words on wheels"
cIvIc
OUtbAcK
cOrvEttE
#cvrtb

AccoRD
eqUINox
exPLoReR
#xeocq

rOguE
MuSTang
CHargEr
WrangLEr
#gnrua`

const id = 'cars-0.0'

const parsed = parseBuilderText(builderText, id);

if (parsed.levelData === null) {
    throw new Error(`Invalid builder text for ${id}`);
}

export const cars: StoryLevelData = parsed.levelData;